import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "switches",
  "use": "switches-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"switches\">\n  <path fill-rule=\"evenodd\" d=\"M205,151h-5.142a3.592,3.592,0,0,0,0-2H205A1,1,0,0,1,205,151Zm-9,2a3,3,0,1,1,3-3A3,3,0,0,1,196,153Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,196,149Zm-5,2a1,1,0,0,1,0-2h1.141a3.617,3.617,0,0,0,0,2H191Zm0,6h5.141a3.617,3.617,0,0,0,0,2H191A1,1,0,1,1,191,157Zm9-2a3,3,0,1,1-3,3A3,3,0,0,1,200,155Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,200,159Zm5-2a1,1,0,1,1,0,2h-1.141a3.617,3.617,0,0,0,0-2H205Z\" transform=\"translate(-190 -147)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/switches.svg
// module id = null
// module chunks = 